<template>
  <v-main
    id="main"
    v-if="payments && tenant"
    class="fill-height fill-width"
    >
    <v-container
      class="ml-n2 pa-0 d-flex justify-center"
      fluid
      >
      <v-card
        id="card"
        class="white"
        flat
        tile
        min-height="29cm"
        width="22cm"
        >
        <v-card-title
          class="white fill-width pb-0 justify-center"
          >
          {{ tenant.profile.name }}
        </v-card-title>

        <v-card-text
          class="white fill-height fill-width"
          >
          <v-row
            class="d-flex flex-row align-center"
            >
            <v-col
              class="pt-0"
              cols="7">
              <div
                class="text-h6"
                >
                {{ currentUser.selectedAgency.name }}
              </div>
              <div
                class="text-subtitle-2"
                >
                {{ currentUser.selectedAgency.address }}
                <br/>
                {{ currentUser.selectedAgency.website }}
                <br/>
                {{ currentUser.selectedAgency.email }}
                <br/>
                {{ currentUser.selectedAgency.phone }}
              </div>
            </v-col>

            <v-col
              cols="2"
              class="pt-0 text-center"
              >
              <div
                class="text-h6"
                >
                {{ receipt.number }}
              </div>
              <div>
                Recibo N°
              </div>
              <div
                class="caption"
                >
                Documento no válido como factura
              </div>
            </v-col>

            <v-col
              cols="3"
              class="pt-0 text-center"
              >
              <img
                class="fill-width"
                :src="require('@/assets/logo.jpeg')"
                ></img>
            </v-col>
          </v-row>

          <v-row>
            <v-col 
              cols="7" 
              class="pt-0 d-flex flex-row justify-space-between"
              >
              <span class="font-weight-bold">Fecha de pago:</span>
              <span>{{ (new Date()).toLocaleDateString() }}</span>
            </v-col>

            <v-col
              cols="12"
              class="py-0 blue--text font-weight-medium"
              >
              Cliente (locatario)
            </v-col>

            <v-col
              cols="12"
              class="py-0"
              >
              {{ tenant.profile.name }}
            </v-col>

            <v-col
              cols="12"
              class="py-0"
              >
              DNI {{ tenant.profile.dni }}
            </v-col>

            <v-col
              cols="12"
              class="py-0"
              >
              {{ tenant.profile.address }}
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-simple-table
                dense
                >
                <template v-slot:default>
                  <thead
                    class="primary">
                    <tr>
                      <th class="text-center white--text">
                        Descripción
                      </th>
                      <th class="text-center white--text">
                        Período
                      </th>
                      <th class="text-right white--text">
                        Precio
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="payment in allPayments"
                      v-if="payment.taxableTag != 'Building'"
                      style="cursor: pointer"
                      @click="openModal(payment)"
                      :key="payment.id"
                      >
                      <td>{{ payment.payableName || payment.concept }}</td>
                      <td
                        class="text-center"
                        >{{ (new Date(payment.dueDate)).toLocaleString('default', { month: 'long' }) }}</td>
                      <td
                        class="text-right"
                        >
                        {{ price(payment.partialAmount, payment.currency) }}
                      </td>
                    </tr>

                    <tr
                      v-if="expensesAmount"
                      :key="expensesAmount"
                      >
                      <td>Expensas</td>
                      <td
                        class="text-center"
                        ></td>
                      <td
                        class="text-right"
                        >
                        {{ price(Math.abs(expensesAmount)) }}
                      </td>
                    </tr>

                    <tr
                      v-if="chargebacks"
                      >
                      <td>
                        Intereses
                      </td>
                      <td
                        class="text-center"
                        >{{ (new Date()).toLocaleString('default', { month: 'long' }) }}</td>
                      </td>
                      <td
                        class="text-right"
                        >
                        {{ price(chargebacks) }}
                      </td>
                    </tr>

                    <tr>
                      <td></td>
                      <td
                        class="text-center font-weight-medium"
                        >
                        Total
                      </td>
                      <td
                        class="text-right"
                        >
                        <div
                          class="text-right"
                          >
                          <div
                            v-for="payment in Object.entries(total)"
                            v-if="payment[1]"
                            >
                            {{ price(payment[1], payment[0]) }}
                          </div>
                        </div>
                      </td>
                    </tr>

                    <template
                      v-for="payment in receipt.paymentTypes"
                      >
                      <tr>
                        <td></td>
                        <td
                          class="text-center font-weight-medium blue--text"
                          >
                          {{ payment.name }}
                        </td>

                        <td
                          class="text-right"
                          width="100"
                          >
                          {{ price(payment.amount, payment.currency) }}
                        </td>
                      </tr>
                    </template>

                    <tr>
                      <td></td>
                      <td
                        class="text-center"
                        >
                        Debe
                      </td>
                      <td
                        class="text-right"
                        >
                        {{ price(lasting) }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>

            <v-col
              cols="12"
              class="text-right"
              v-if="!printing"
              >
              <create-payment-types
                :id="receipt.id"
                :paymentTypes="receipt.paymentTypes"
                @reload="fetchPayments"
                ></create-payment-types>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              class="font-weight-medium"
              >
              Firma
            </v-col>
          </v-row>

          <v-divider></v-divider>
        </v-card-text>
      </v-card>

      <v-btn
        fab
        fixed
        bottom
        right
        color="primary"
        class="rounded-circle d-print-none"
        @click="print"
        >
        <v-icon>
          mdi-printer
        </v-icon>
      </v-btn>

    </v-container>
  </v-main>
</template>

<script>
import { Print } from '@/graphql/mutations/receipts' 
import { Receipt } from '@/graphql/queries/receipt' 
import { Collections } from '@/graphql/queries/payment' 
import { Contact } from '@/graphql/queries/directory'
import { mapGetters } from 'vuex'
import html2pdf from 'html2pdf.js'
import $ from 'jquery'

import CreatePaymentTypes from '@/components/payments/receipts/CreatePaymentTypes'

export default {
  data () {
    return {
      modal: false,
      selected: null,
      tenant: null,
      receipt: null,
      payments: null,
      printing: false,
      expensesAmount: 0,
      total: {
        "ARS": 0,
        "USD": 0
      }
    }
  },

  mounted () {
    this.fetchTenant()
    this.fetchPayments()
  },

  computed: {
    ...mapGetters(['currentUser']),

    contract () {
      return (this.tenant.activeContracts[0] || this.receipt.contract)
    },

    paid () {
      return this.payments.filter( p => p.state == 'paid').reduce((a, b) => {
        if (b.receiverId == this.tenant.id && b.receiverType == 'User') {
          var amount = a - Math.abs((b['partialAmount'] || 0))
        } else {
          var amount = a + Math.abs((b['partialAmount'] || 0))
        }
        return amount
      }, 0) + this.partialAmount + this.chargebacks
    },

    pending () {
      return this.payments.filter( p => p.state == 'pending').reduce((a, b) => {
        if (b.receiverId == this.tenant.id && b.receiverType == 'User') {
          var amount = a - Math.abs((b['total'] || 0))
        } else {
          var amount = a + Math.abs((b['total'] || 0))
        }
        return amount
      }, 0);
    },

    lasting () {
      return this.payments.filter( p => p.state == 'pending').reduce((a, b) => {
        if (b.receiverId == this.tenant.id && b.receiverType == 'User') {
          var amount = a - Math.abs(b['lastingAmount'] || 0)
        } else {
          var amount = a + Math.abs(b['lastingAmount'] || 0)
        }
        return amount
      }, 0);
    },

    partialAmount () {
      return this.payments.filter( p => p.state == 'pending').reduce((a, b) => {
        if (b.receiverId == this.tenant.id && b.receiverType == 'User') {
          var amount = a - Math.abs(b['partialAmount'] || 0)
        } else {
          var amount = a + Math.abs(b['partialAmount'] || 0)
        }
        return amount
      }, 0);
    },

    chargebacks () {
      let amount = 0

      this.allPayments.forEach(p => {
        p.chargebacks.forEach( c => {
          if (c.active){
            amount += c.amount
          }
        })
      })

      return amount
    },

    allPayments () {
      return this.payments.filter( p => p.state == 'paid').concat(this.payments.filter( p => p.state == 'pending'))
    },
  },

  methods: {
    fetchPayments () {
      this.$apollo.query({
        query: Receipt,
        variables: {
          id: this.$route.params.id
        },
        fetchPolicy: 'no-cache'
      }).then(res => {
        this.total = {
          "USD": 0,
          "ARS": 0
        }

        this.receipt = res.data.receipt
        this.payments = res.data.receipt.payments

        this.expensesAmount = 0
        this.payments.forEach ( payment => {
          this.total[payment.currency] += payment.lastingAmount
          if (payment.taxableTag == 'Building') {
            this.expensesAmount += payment.total
          }
        })
      })
    },

    fetchTenant (policy = 'cache-first') {
      this.$apollo.query({
        query: Contact,
        variables: {
          contactId: this.$route.params.user_id
        },
        fetchPolicy: policy
      }).then(res => {
        this.tenant = res.data.contact
      })
    },

    print () {
      this.printing = true

      this.$apollo.mutate({
        mutation: Print,
        variables: {
          input: {
            id: this.$route.params.id
          }
        }
      }).then( res => {
        var element = document.body;
        html2pdf(element, {
          margin: 0,
          filename: 'document.pdf',
          image: { type: 'jpg', quality: 0.98 },
          html2canvas: { dpi: 192, letterRendering: true, useCORS: true },
          jsPDF: { unit: 'cm', format: 'a4', orientation: 'portrait' }
        })

        this.printing = false
      })
    },

    imageUrl (url) {
      return process.env.VUE_APP_RAILS_URL + url
    },

    price (price, currency = "ARS") {
      var formatter = new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: currency,

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
      });

      return formatter.format(price); /* $2,500.00 */
    },

    openModal (payment) {
      this.selected = payment
      this.modal = true
    },

    reload () {
      this.fetchPayments ()
    }
  },

  components: {
    CreatePaymentTypes
  }
}
</script>
